export default __webpack_public_path__ + "static/media/Designo - Preview 2.21d2ed95.png";